import React from "react";
import { Outlet } from "react-router-dom";

function Index() {
  return <Outlet />;
}

export default Index;
